module.exports = __webpack_public_path__ + "static/media/virtual.5399fa85.webp";